module.exports = __webpack_public_path__ + "static/media/fvs_fremdlinge_31.392d1f77.jpg";